module.exports = __webpack_public_path__ + "media/slot-game/king-2fcfff9e.svg";